import H5ImageSearchGuide from './index.vue'
import { createFuncall } from 'vue-funcall'

export const showH5ImageSearchGuide = ({ options, ...props } = {}) => {
  const { close } = createFuncall(H5ImageSearchGuide, {
    show: true,
    transitionAppear: true,
    onClosed () {
      close()
    },
    ...props
  }, options)

  return { close }
}
